// Base Imports
import React, { useRef } from "react";

// Package Imports
import { Formik, Form } from "formik";

// Other Imports
import { matchStrings } from "@framework/utils/parse-util";
import { findByFieldName } from "@framework/utils/app-util";
import FormField from "@components/utils/ui/FormField";
import SubmitButton from "@components/common/SubmitButton";
import { DeliveryInfoPageAction } from "@components/utils/constants";

interface IDeliveryInfoFormProps {
    readonly submitState: any;
    readonly formId: string;
    readonly schema: any;
    readonly initialValues?: any;
    readonly defaultValues?: any;
    readonly formFields: Array<any>;
    onSubmit?: Function;
    setEDD?:Function;
    edd?:string;
}

const DeliveryInfoForm = (props: IDeliveryInfoFormProps) => {
    const deliveryFormRef: any = useRef(null);
    const
        {
            submitState,
            formId,
            schema,
            initialValues = null,
            defaultValues,
            formFields,
            onSubmit = () => { },
            setEDD = () => {},
            edd
        } = props;
    const initState = defaultValues
        ? Object.keys(defaultValues).length
            ? defaultValues
            : initialValues
        : initialValues;

    return (
        <Formik
            innerRef={deliveryFormRef}
            validateOnChange={false}
            validateOnBlur={false}
            validationSchema={schema}
            initialValues={initState}
            onSubmit={(values) => {
                const payload = {
                    ...values,
                };
                onSubmit(payload);
            }}
        >
            {(context) => {

                const {
                    errors,
                    touched,
                    handleSubmit,
                    values,
                    handleChange,
                    setValues,
                    handleBlur,
                    resetForm
                } = context;
            
                return (
                    <Form
                        id={formId}
                        onSubmit={handleSubmit}
                    >
                        <div className='relative grid grid-cols-1 my-4'>

                            {
                                (formFields?.length
                                    ? Array.from<any>([]).concat([
                                        findByFieldName(formFields, "deliveryPinCode"),
                                    ])
                                    : [])?.map((item: any, idx: number) => (
                                        <FormField
                                            key={idx}
                                            context={context}
                                            item={item}
                                        />
                                    ))
                            }
                            {
                                !(edd && !matchStrings(edd, "", true))
                                    ?<SubmitButton
                                        formId={formId}
                                        cssClass="absolute text-sm font-semibold text-orange-600 top-4 right-5 hover:text-orange"
                                        submitState={submitState}
                                        source={DeliveryInfoPageAction.COMPUTE_EDD}
                                    >
                                        {"Check Delivery Date"}
                                    </SubmitButton>
                                    :<button onClick={() => {setEDD(undefined);resetForm()}} className="absolute text-sm font-semibold text-orange-600 top-4 right-5 hover:text-orange">
                                        {"Change"}
                                    </button>
                            } 
                        </div>

                    </Form>
                );
            }}
        </Formik>
    );
}

export default DeliveryInfoForm;